// Usage: https://github.com/caroso1222/notyf
import { Notyf } from 'notyf';

export default {
    init() {
        return new Notyf({
            duration: 5000,
            position: {
                x: "right",
                y: "top"
            },
            types: [
                {
                    type: "info",
                    backgroundColor: Syn.theme.info
                },
                {
                    type: "success",
                    backgroundColor: Syn.theme.success
                },
                {
                    type: "warning",
                    backgroundColor: Syn.theme.warning
                },
                {
                    type: "danger",
                    backgroundColor: Syn.theme.danger
                }
            ]
        });
    }
}
